// fetchWithAuth.js
import { getAuthToken } from './ utils/getToken';

export async function fetchWithAuth(path, options = {}) {
  const token = getAuthToken();
  const baseURL =""
    // window.location.hostname === 'localhost'
    //   ? ''
    //   : 'https://sandbox.atslrail.com';

  const res = await fetch(`${baseURL}${path}`, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.message || 'Fetch error');
  }

  return res.json();
}
